export default __webpack_public_path__ + "static/media/Int_SII.4c6ec4f8.svg";